import { render } from "./Three4Charts.vue?vue&type=template&id=07d82c5d&scoped=true"
import script from "./Three4Charts.vue?vue&type=script&lang=js"
export * from "./Three4Charts.vue?vue&type=script&lang=js"

import "./Three4Charts.vue?vue&type=style&index=0&id=07d82c5d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d82c5d"]])

export default __exports__